import { MprcLink } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { PublicationViewerDialog } from "views/knowledge/publication/dialogs/PublicationViewerDialog";
import { useCardContext } from "../../CardBuilder";

///
export const ModerateReportsCommentTitle = () => {
    const { pub: { publicationId, title } } = useCardContext();
    const { t } = useTranslation("knowledge");
    const [dialog, setDialog] = useState<any>(null);
    return (
        <>
            {dialog}
            <MprcLink
                onClick={
                    () => setDialog(
                        <PublicationViewerDialog
                            publicationId={publicationId}
                            onClose={() => setDialog(null)}
                        />
                    )
                }
            >
                <MprcFeedTypography variant="title" component="div" noWrap={true}>
                    <span title={title}>{t("Feed.Card.ModerateReports.CommentTitlePrefix")}: {title}</span>
                </MprcFeedTypography>
            </MprcLink>
        </>
    );
};
